import { render, staticRenderFns } from "./BidRequestEmptyPopup.vue?vue&type=template&id=86e3814e&"
import script from "./BidRequestEmptyPopup.vue?vue&type=script&lang=js&"
export * from "./BidRequestEmptyPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports